import styled from '@emotion/styled';
import { css } from '@emotion/react';

interface IStyledModal {
    transitionDuration: number;
    fullWidthContent?: boolean;
    showModal: boolean;
}

export const StyledModalWrapper = styled.div<IStyledModal>`
    background: ${(props) => props.theme.shades.white};
    transition: ${(props) => `all ${props.transitionDuration}ms ease`};
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    top: 0;
    transform: translate3d(100%, 0, 0);
    padding: 12px;

    > div {
        height: 100%;
    }

    ${(props) => {
        return (
            props.fullWidthContent &&
            css`
                padding: 0;
            `
        );
    }}
    ${(props) => {
        return (
            props.showModal &&
            css`
                transform: translate3d(0, 0, 0);
            `
        );
    }}
`;

export const StyledModalBodyWrapper = styled.div`
    padding: 20px 0 0;
    height: 100%;
`;

export const StyledModalHeaderWrapper = styled.div<{ fullWidthContent?: boolean }>`
    display: flex;
    justify-content: space-between;
    margin-top: 5px;
    color: ${(props) => props.theme.shades.blackGrey};
    ${(props) => {
        return (
            props.fullWidthContent &&
            css`
                padding: 12px 0 0 12px;
            `
        );
    }}
`;
export const StyledModalHeaderHeadline = styled.h3`
    font-size: 20px;
    line-height: 1.2;
    margin: 0;
    font-weight: 500;
    width: 100%;
    text-align: center;
`;
export const StyledModalHeaderBackButton = styled.button`
    outline: none;
    background: none;
    padding-left: 0;
    border: 0;
`;
export const StyledModalHeaderRightIcon = styled.span`
    color: ${(props) => props.theme.colors.main4};
    &,
    & > * {
        font-size: 11px !important;
    }
`;
